import { IApplicationState } from '../../types/redux';

export function selectFeedbackFormLoadEnabled(state: IApplicationState) {
  return state.feedbackForm.loadFormEnabled;
}
